export const JOB_TITLE_REQUIRED = "Title is required";
export const JOB_CITIES_REQUIRED = "Select at least one city";
export const JOB_RATE_CARD_REQUIRED = "Select a rate card";
export const JOB_CTC_RANGE_ERROR = "Minimum CTC cannot be above maximum CTC";
export const JOB_FEE_SPLIT_ERROR = "Fee split must add up to 100%";
export const JOB_WALKIN_ADDRESS_REQUIRED = "Enter the walk-in venue address";
export const JOB_FEE_SPLIT_TOTAL = 100;

export function validateJobTitle(value: string): string | null {
  return value.trim().length >= 2 ? null : JOB_TITLE_REQUIRED;
}

export function validateJobCities(cities: string[]): string | null {
  return cities.length >= 1 ? null : JOB_CITIES_REQUIRED;
}

export function validateJobRateCard(contractId: string, hasContracts: boolean): string | null {
  if (!hasContracts) return null;
  return contractId ? null : JOB_RATE_CARD_REQUIRED;
}

export function validateWalkinAddress(address: string, isWalkin: boolean): string | null {
  return isWalkin && !address.trim() ? JOB_WALKIN_ADDRESS_REQUIRED : null;
}

export function validateJobCtcRange(min?: number, max?: number): string | null {
  if (min == null || max == null) return null;
  if (!Number.isFinite(min) || !Number.isFinite(max)) return JOB_CTC_RANGE_ERROR;
  return min > max ? JOB_CTC_RANGE_ERROR : null;
}

export function validateJobFeeSplit(sourcing: number, recruiter: number, platform: number): string | null {
  if (![sourcing, recruiter, platform].every((value) => Number.isFinite(value))) {
    return JOB_FEE_SPLIT_ERROR;
  }
  return sourcing + recruiter + platform === JOB_FEE_SPLIT_TOTAL ? null : JOB_FEE_SPLIT_ERROR;
}
